import React, {useCallback, useState} from 'react';
import {Box, Button, CircularProgress, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {useRetrieveUserInfo} from "../hooks/useRetrieveUserInfo";
import {User} from "../types";

interface IUserInfoCardProps {
    setUser: (user: User | null) => void;
}

function SearchForm({setUser}: IUserInfoCardProps) {
    const [userId, setUserId] = useState('')
    const {retrieveUserInfo, isLoading} = useRetrieveUserInfo()

    const findUser = useCallback(async () => {
        const data = await retrieveUserInfo(userId)
        setUser(data)
    }, [retrieveUserInfo, setUser, userId]);

    return (
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, mt: 2}}>
            <TextField id="user-data" label="Enter user email or key" variant="standard" size="small"
                       sx={{minWidth: '20rem'}}
                       onChange={(e) => setUserId(e.currentTarget.value)}/>
            <Button variant="contained"
                    size="small"
                    startIcon={isLoading ? <CircularProgress size="1rem"/> : <SearchIcon/>}
                    onClick={findUser}
                    disabled={isLoading}>
                Search
            </Button>
        </Box>
    );
}

export default SearchForm;
